import type { DuelResult } from "../types/leagueDuel";

// ─── Système ELO 1v1 ──────────────────────────────────────────────────────────
// Formule ELO classique. Plus l'adversaire est fort, plus une victoire rapporte
// (et moins une défaite coûte). Fonctions pures + petit store localStorage.

// Échelle "petits nombres" : départ 100, divisions tous les 100 pts (Silver 100
// → Diamond 600). L'ELO est invariant par translation — seuls les affichages et
// les calibrages dérivés du MMR (stats bots, rareté visuelle) suivent l'échelle.
export const START_ELO = 100;
export const K_FACTOR = 32;

const STORE_KEY = "league_duel_elo";

/** Probabilité attendue de victoire de `elo` contre `oppElo` (0..1). */
export function expectedScore(elo: number, oppElo: number): number {
  return 1 / (1 + Math.pow(10, (oppElo - elo) / 400));
}

/** Variation d'ELO (points gagnés/perdus) selon le résultat. */
export function eloDelta(
  elo: number,
  oppElo: number,
  result: DuelResult,
  k: number = K_FACTOR
): number {
  const actual = result === "win" ? 1 : result === "draw" ? 0.5 : 0;
  return Math.round(k * (actual - expectedScore(elo, oppElo)));
}

/** Lit l'ELO du joueur (localStorage), défaut START_ELO. */
export function loadPlayerElo(): number {
  try {
    const v = Number(localStorage.getItem(STORE_KEY));
    return Number.isFinite(v) && v > 0 ? v : START_ELO;
  } catch {
    return START_ELO;
  }
}

/** Persiste l'ELO du joueur. */
export function savePlayerElo(elo: number): void {
  try {
    localStorage.setItem(STORE_KEY, String(Math.max(0, Math.round(elo))));
  } catch {}
}
